module.exports = __webpack_public_path__ + "components/flag/static/square/vi-91d0340468082cd9493811d13e4a7bcd.svg";